import React, { Fragment } from 'react';

import RequiredInput from '../../../common/RequiredInput';

const Form = (props) => {
  const genTitle = () => {
    if (props.dataList.length > 0) {
      return (
        <div className="trans trans-tt">
          <div className="bef">
            <p className="name">{props.keyLabel}</p>
          </div>
          <span className="center-wd"></span>
          <div className="aft">
            <p className="name">{props.valueLabel}</p>
          </div>
          <span className="iconarea"></span>
        </div>
      );
    }
    return null;
  };

  return (
    <Fragment>
      <span className="info-tt">{props.title}</span>
      <div className="info-des">
        <div className="field-trans-form">
          {genTitle()}
          {props.dataList.map((item, index) => (
            <div className="trans trans-con">
              <div className="bef">
                <div className="trans">
                  <RequiredInput
                    placeholder={`请输入${props.keyLabel}`}
                    value={item.key}
                    onChange={(event, value) => {
                      props.onItemChange(index, 'key', value);
                    }}
                    status={item.status}
                  />
                </div>
              </div>
              <span className="center-wd">对应</span>
              <div className="aft">
                <RequiredInput
                  placeholder={`请输入${props.valueLabel}`}
                  value={item.value}
                  onChange={(event, value) => {
                    props.onItemChange(index, 'value', value);
                  }}
                  status={item.status}
                />
              </div>
              <i
                className="iconarea"
                onClick={() => {
                  props.onDeleteItem(index);
                }}
              >
                <i className="icon icon-delete"></i>
              </i>
            </div>
          ))}
          <a className="add-fields-des" onClick={props.onAdd}>
            <span className="add-ico">+</span> {`添加${props.title}`}
          </a>
        </div>
      </div>
    </Fragment>
  );
};

export default Form;
